import React from 'react';

import './loader.scss';

export default React.memo(() => (
  <div className="ldsRipple">
    <div />
    <div />
  </div>
));
